import { render, staticRenderFns } from "./createTagModal.vue?vue&type=template&id=d0639e92&scoped=true"
import script from "./createTagModal.vue?vue&type=script&lang=js"
export * from "./createTagModal.vue?vue&type=script&lang=js"
import style0 from "./createTagModal.vue?vue&type=style&index=0&id=d0639e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0639e92",
  null
  
)

export default component.exports